import { Res } from './responses'

export const responses: Res = {
  companies: [
    {
      chargee_id: 'Praesentium ab autem.',
      id: 'Res.companies.0.id',
      name: 'Coupe',
      subscriptions: [
        {
          addons: [
            {
              description:
                'Dolore libero aliquam natus repellendus esse ab esse.',
              name: 'incidentally',
              price: 5,
            },
            {
              description: 'Dolorem enim ipsam aperiam dignissimos harum qui.',
              name: 'Bicycle',
              price: 6,
            },
          ],
          billing_period: 2,
          chargebee_id:
            'Sequi porro labore necessitatibus iusto officia animi beatae tempora.',
          description: 'Modi quae harum sapiente.',
          id: 'Res.companies.0.subscriptions.0.id',
          name: 'specific',
          price: 8,
          total: 6,
        },
      ],
    },
    {
      chargee_id: 'Occaecati voluptatum molestiae velit.',
      id: 'Res.companies.1.id',
      name: 'Tactics',
      subscriptions: [
        {
          billing_period: 2,
          chargebee_id: 'Fugit at reiciendis.',
          description: 'Quos illum adipisci temporibus tenetur quo.',
          id: 'Res.companies.1.subscriptions.4.id',
          name: 'Silicon',
          price: 1,
          total: 6,
        },
        {
          addons: [
            {
              description: 'Aliquid voluptates eum.',
              name: 'Licensed',
              price: 4,
            },
            {
              description: 'Molestias ullam repellendus.',
              name: 'Forint',
              price: 2,
            },
            { description: 'Numquam velit id.', name: 'facilitate', price: 4 },
            {
              description:
                'Atque fuga nobis repellendus tempora delectus accusamus sint praesentium ducimus.',
              name: 'invoice',
              price: 8,
            },
          ],
          billing_period: 2,
          chargebee_id:
            'Ipsa repudiandae at nostrum repudiandae expedita nisi odio accusamus odit.',
          description: 'Maiores porro beatae iste.',
          id: 'Res.companies.1.subscriptions.5.id',
          name: 'Island',
          price: 7,
          total: 6,
        },
      ],
    },
    {
      chargee_id:
        'Excepturi suscipit eligendi corrupti saepe voluptatem corporis.',
      id: 'Res.companies.7.id',
      name: 'bluetooth',
      subscriptions: [
        {
          addons: [
            {
              description: 'Unde aliquid animi voluptas odit minima voluptate.',
              name: 'Gender',
              price: 4,
            },
            {
              description:
                'Atque necessitatibus inventore sed alias quam dolorem quo laudantium enim.',
              name: 'that',
              price: 2,
            },
          ],
          billing_period: 2,
          chargebee_id:
            'Velit deleniti eaque porro quisquam voluptatum tempore.',
          description: 'Nulla sit officiis cum deleniti aliquam minima.',
          id: 'Res.companies.7.subscriptions.0.id',
          name: 'Auto',
          price: 8,
          total: 9,
        },
        {
          billing_period: 2,
          chargebee_id:
            'Iste fugiat eos molestiae deserunt esse consequatur dolor aliquid.',
          description:
            'Quisquam possimus placeat aperiam repudiandae ad quasi laborum.',
          id: 'Res.companies.7.subscriptions.1.id',
          name: 'gosh',
          price: 1,
          total: 4,
        },
        {
          billing_period: 2,
          chargebee_id: 'Quis aut adipisci libero adipisci sed.',
          description: 'Temporibus pariatur quod optio.',
          id: 'Res.companies.7.subscriptions.2.id',
          name: 'searchingly',
          price: 1,
          total: 2,
        },
      ],
    },
  ],
  invoiceDownload: {
    url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  },
  invoices: [
    {
      date: 1681909682080,
      due_date: 5681909682080,
      id: 'Res.invoices.0.id',
      line_items: [
        {
          amount: 9,
          description: 'Debitis quisquam',
          discount_amount: 9,
          entity_type: 'adhoc',
          id: 'Res.invoices.0.line_items.0.id',
          item_level_discount_amount: 5,
          pricing_model: 'Adipisci expedita assumenda architecto.',
          quantity: 3,
          tax_amount: 5,
          unit_amount: 7,
        },
        {
          amount: 1,
          description: 'Tenetur expedita',
          discount_amount: 9,
          entity_type: 'plan_item_price',
          id: 'Res.invoices.0.line_items.1.id',
          item_level_discount_amount: 5,
          pricing_model: 'Possimus natus maiores ea deserunt laborum fugit.',
          quantity: 6,
          tax_amount: 7,
          unit_amount: 3,
        },
        {
          amount: 3,
          description: 'At facilis pariatur',
          discount_amount: 2,
          entity_type: 'addon_item_price',
          id: 'Res.invoices.0.line_items.2.id',
          item_level_discount_amount: 7,
          pricing_model: 'Quis ab quos distinctio facere.',
          quantity: 4,
          tax_amount: 1,
          unit_amount: 8,
        },
        {
          amount: 1,
          description: 'Asperiores ',
          discount_amount: 9,
          entity_type: 'charge_item_price',
          id: 'Res.invoices.0.line_items.5.id',
          item_level_discount_amount: 2,
          pricing_model:
            'Provident ipsum nobis quis omnis deserunt cumque ad doloribus.',
          quantity: 9,
          tax_amount: 3,
          unit_amount: 3,
        },
      ],
      status: 'paid',
      status: 'Quae nostrum ut rerum.',
      total: 9,
      total: 3,
    },
    {
      date: 1681909682080,
      due_date: 5681909682080,
      id: 'Res.invoices.1.id',
      line_items: [
        {
          amount: 4,
          description: 'Sapiente',
          discount_amount: 6,
          entity_type: 'charge_item_price',
          id: 'Res.invoices.1.line_items.0.id',
          item_level_discount_amount: 9,
          pricing_model: 'Non aspernatur blanditiis.',
          quantity: 5,
          tax_amount: 4,
          unit_amount: 4,
        },
        {
          amount: 8,
          description: 'Alias est',
          discount_amount: 7,
          entity_type: 'charge_item_price',
          id: 'Res.invoices.1.line_items.1.id',
          item_level_discount_amount: 5,
          pricing_model: 'Amet eum eum id at consequuntur.',
          quantity: 1,
          tax_amount: 1,
          unit_amount: 2,
        },
        {
          amount: 1,
          description: 'Veniam sint blanditiis',
          discount_amount: 7,
          entity_type: 'adhoc',
          id: 'Res.invoices.1.line_items.2.id',
          item_level_discount_amount: 5,
          pricing_model: 'Numquam nemo ipsam omnis sequi qui ducimus.',
          quantity: 4,
          tax_amount: 1,
          unit_amount: 6,
        },
      ],
      status: 'paid',
      status: 'Eum minus voluptatem.',
      total: 5,
      total: 4,
    },
    {
      date: 1681909682080,
      due_date: 5681909682080,
      id: 'Res.invoices.2.id',
      line_items: [
        {
          amount: 8,
          description: 'Asperiores laboriosam perferendis',
          discount_amount: 1,
          entity_type: 'adhoc',
          id: 'Res.invoices.2.line_items.0.id',
          item_level_discount_amount: 5,
          pricing_model: 'Ducimus corporis accusantium omnis occaecati.',
          quantity: 1,
          tax_amount: 3,
          unit_amount: 2,
        },
      ],
      status: 'paid',
      status: 'Ratione temporibus occaecati ipsa.',
      total: 10,
      total: 6,
    },
    {
      date: 1681909682080,
      due_date: 5681909682080,
      id: 'Res.invoices.4.id',
      line_items: [
        {
          amount: 5,
          description: 'Quo quam',
          discount_amount: 4,
          entity_type: 'plan_item_price',
          id: 'Res.invoices.3.line_items.0.id',
          item_level_discount_amount: 3,
          pricing_model:
            'Quam doloremque nemo nulla maxime explicabo repudiandae.',
          quantity: 6,
          tax_amount: 7,
          unit_amount: 4,
        },
        {
          amount: 9,
          description: 'Doloribus quisquam',
          discount_amount: 9,
          entity_type: 'plan_item_price',
          id: 'Res.invoices.3.line_items.5.id',
          item_level_discount_amount: 2,
          pricing_model:
            'Minus corrupti ex accusamus quae ducimus dignissimos.',
          quantity: 6,
          tax_amount: 3,
          unit_amount: 4,
        },
        {
          amount: 7,
          description: 'Veniam recusandae',
          discount_amount: 9,
          entity_type: 'charge_item_price',
          id: 'Res.invoices.3.line_items.6.id',
          item_level_discount_amount: 1,
          pricing_model: 'Sit quae molestias esse accusantium.',
          quantity: 2,
          tax_amount: 1,
          unit_amount: 9,
        },
      ],
      status: 'paid',
      status: 'Iure inventore at culpa sunt aspernatur quasi.',
      total: 91,
      total: 9,
    },
  ],
  login: {},
  manageSubscription: {
    url: 'https://google.com',
  },
  offer: {
    background_color: 'Aspernatur id architecto quasi quaerat.',
    background_gradient: 'Ullam illo dolorem esse adipisci commodi.',
    brand: {
      description: 'Aliquid vero commodi beatae molestias delectus.',
      id: 'Res.offer.brand.id',
      logo: { url: 'Rerum at iure tempora.' },
      name: 'pro',
    },
    content: 'Nisi natus iusto est laborum iste suscipit illum.',
    description:
      'Accusantium modi soluta vel sapiente doloribus maiores exercitationem.',
    featured: false,
    hero_description: 'Maiores nostrum vero dignissimos occaecati.',
    hero_image: { url: 'Dolore harum fugit quidem ipsum consequatur.' },
    id: 'Res.offer.id',
    image: { url: 'Eius quo nulla ipsum iste.' },
    requirements: ['MEMBER'],
    screenshots: [
      { url: 'Consequuntur vel culpa dicta.' },
      {
        url: 'Itaque maxime consequatur saepe ut ea dicta eum ducimus magnam.',
      },
      { url: 'Numquam sapiente itaque aperiam adipisci rerum.' },
      { url: 'Veritatis corrupti vero cum quia odio cum commodi.' },
    ],
    secured: false,
    tags: [
      'Repudiandae esse sint aliquam velit.',
      'Unde totam incidunt amet.',
      'Et voluptas vitae consequuntur atque corrupti autem quam quos.',
      'Reiciendis facere cupiditate.',
      'Illo nostrum qui sapiente deleniti quae non quae quos impedit.',
      'Ipsam recusandae accusamus doloribus molestiae quibusdam consequatur.',
      'Blanditiis tempore delectus inventore culpa.',
      'Corporis quia exercitationem consequuntur sit eligendi unde accusamus aliquam.',
      'In praesentium asperiores quo odit incidunt officiis exercitationem.',
    ],
    terms_content: 'Nulla ad doloremque iste laudantium dolorum adipisci.',
    title: 'Vel placeat consectetur quae deleniti.',
  },
  offerRedemption: {
    url: 'Ullam consequuntur vel delectus distinctio a aliquam accusamus ea laborum.',
  },
  offers: {
    count: 7,
    next: 'https://familiar-charter.info',
    previous: 'http://considerate-status.net',
    results: [
      {
        background_color: 'Tempore iure aliquid culpa architecto dolorem.',
        background_gradient: 'Sequi at praesentium blanditiis placeat.',
        brand: {
          description:
            'Pariatur maxime architecto sapiente tempora rerum deleniti.',
          id: 'Res.offers.results.0.brand.id',
          logo: {
            url: 'Doloremque cumque quasi aspernatur porro aliquam voluptas blanditiis quibusdam.',
          },
          name: 'Northeast',
        },
        description: 'Neque similique impedit.',
        featured: false,
        id: 'Res.offers.results.0.id',
        image: { url: 'In reiciendis maxime repellat cum.' },
        secured: false,
        tags: [
          'Nesciunt sequi quas dolorem optio provident sed expedita.',
          'Quas mollitia placeat rem sequi quidem.',
          'Nemo modi ut non minima.',
        ],
        title: 'Commodi aspernatur porro adipisci vero reiciendis deserunt a.',
      },
      {
        background_color:
          'Eum assumenda dolorem nostrum nemo iusto asperiores.',
        background_gradient:
          'Facere doloribus in eligendi repudiandae quidem consequuntur tempore.',
        brand: {
          description: 'Rerum magnam recusandae commodi laboriosam ipsam.',
          id: 'Res.offers.results.1.brand.id',
          logo: { url: 'Ipsa deserunt non esse consequuntur.' },
          name: 'female',
        },
        description: 'Non numquam officia natus illum dicta.',
        featured: false,
        id: 'Res.offers.results.1.id',
        image: { url: 'Natus aut velit ut nobis ut minima eos nulla.' },
        secured: false,
        tags: [
          'Iusto non quam corrupti dignissimos optio.',
          'Aut fugiat possimus voluptate incidunt cupiditate porro ratione porro.',
          'Iste voluptatem maxime placeat aspernatur quos harum sequi error.',
          'Et tempore doloremque quibusdam voluptas quia minima et.',
        ],
        title: 'Quam commodi atque.',
      },
      {
        background_color:
          'Exercitationem debitis quidem magnam sed voluptas facilis nulla facere aperiam.',
        brand: {
          description: 'Nobis omnis voluptates pariatur tempora magnam.',
          id: 'Res.offers.results.2.brand.id',
          logo: { url: 'Debitis optio a temporibus laboriosam dolores.' },
          name: 'Oregon',
        },
        description:
          'Magni nam occaecati debitis a rerum quia laborum ut expedita.',
        featured: false,
        id: 'Res.offers.results.2.id',
        image: { url: 'Sapiente error ab nemo esse error.' },
        secured: true,
        tags: [
          'Aperiam culpa temporibus consequuntur labore sed occaecati mollitia recusandae iste.',
          'Nulla animi officiis dolores perspiciatis consequatur.',
          'Commodi eos ullam perferendis cumque illum mollitia rem.',
        ],
        title: 'Pariatur tenetur eveniet error temporibus.',
      },
      {
        background_color: 'Temporibus voluptas magnam.',
        background_gradient:
          'Reiciendis pariatur pariatur in veritatis animi libero corporis nam.',
        brand: {
          description: 'Reprehenderit repellendus enim placeat.',
          id: 'Res.offers.results.3.brand.id',
          logo: { url: 'Ea porro quas eum assumenda ipsa nihil.' },
          name: 'API',
        },
        description: 'Beatae quasi beatae doloremque nulla magni.',
        featured: false,
        id: 'Res.offers.results.3.id',
        image: {
          url: 'Illo asperiores aliquam molestias ducimus fugit explicabo.',
        },
        secured: false,
        tags: [
          'Praesentium dolores nulla quam officiis dolorum ex rem nemo.',
          'Ea fuga quidem beatae.',
          'Laborum nam iure asperiores.',
        ],
        title: 'Quasi eos quisquam quia cupiditate.',
      },
    ],
  },
  paymentSources: [
    {
      created_at: 1681909682080,
      id: 'Res.paymentSources.0.id',
      status: 'valid',
      type: 'direct_debit',
    },
    {
      created_at: 1681909682080,
      id: 'Res.paymentSources.1.id',
      status: 'invalid',
      type: 'paypal_express_checkout',
    },
  ],
  redirect: {
    url: 'Praesentium harum in nisi ullam facere facilis provident.',
  },
  tags: [
    { id: 'Res.tags.0.id', name: 'Metal', tag_type: 'OFFER' },
    { id: 'Res.tags.1.id', name: 'Innovative', tag_type: 'OFFER' },
    { id: 'Res.tags.2.id', name: 'Mauritius', tag_type: 'OFFER' },
    { id: 'Res.tags.3.id', name: 'qualify', tag_type: 'OFFER' },
    { id: 'Res.tags.4.id', name: 'Investment', tag_type: 'OFFER' },
    { id: 'Res.tags.5.id', name: 'Tactics', tag_type: 'OFFER' },
    { id: 'Res.tags.6.id', name: 'Taiwan', tag_type: 'OFFER' },
    { id: 'Res.tags.7.id', name: 'male', tag_type: 'OFFER' },
    { id: 'Res.tags.8.id', name: 'Soft', tag_type: 'OFFER' },
  ],
  user: {},
}
